export function normalizeSignupPhone(value) {
  const trimmed = value.trim();
  if (!/^\+?[\d\s().-]+$/.test(trimmed)) {
    throw new Error('Enter a valid phone number, not an email address.');
  }
  const digits = trimmed.replace(/\D/g, '');
  if (trimmed.startsWith('+') && /^[1-9]\d{7,14}$/.test(digits)) return `+${digits}`;
  if (!trimmed.startsWith('+') && digits.length === 10) return `+1${digits}`;
  if (!trimmed.startsWith('+') && digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  throw new Error('Enter a 10-digit US phone number or an international number starting with +.');
}


// Cognito usernames are immutable; normalize phone logins exactly as signup does.
export function normalizeLoginUsername(value) {
  const username = value.trim();
  return username.includes('@') ? username.toLowerCase() : normalizeSignupPhone(username);
}
